export const Units = [
	{
		name: 'LEITHY MEKKAWY DESIGN TOWNHOUSE',
		nameAr: 'تاون هاوس ليثي مكاوي للتصميم',
		images: [
			'../../assets/images/allegria-images/leithy-mekkawy/image1.jpeg',
			'../../assets/images/allegria-images/leithy-mekkawy/image2.jpeg',
			'../../assets/images/allegria-images/leithy-mekkawy/image3.jpeg',
			'../../assets/images/allegria-images/leithy-mekkawy/image4.jpeg'
		],
		location: 'PHASE 4, SEMI FINISHED',
		locationAr: 'المرحلة 4 ، نصف منتهية',
		landArea: 250,
		buildingArea: 261,
		floors: 3,
		guard: 9
	},
	{
		name: 'SCENIC PARK',
		nameAr: 'ساينس بارك',
		images: [
			'../../assets/images/allegria-images/scenic-park/image1.jpeg',
			'../../assets/images/allegria-images/scenic-park/image2.jpeg',
			'../../assets/images/allegria-images/scenic-park/image3.jpeg',
			'../../assets/images/allegria-images/scenic-park/image4.jpeg'
		],
		location: 'SEMI FINISHED MARK MACK SV DESIGN VILLA',
		locationAr: 'فيلا نصف تشطيب مارك ماك اس في ديزاين',
		landArea: 600,
		buildingArea: 340,
		floors: 2,
		guard: 9
	},
	{
		name: 'MICHAEL GRAVES',
		nameAr: 'مايكل جريفز',
		images: [
			'../../assets/images/allegria-images/michael-graves/image1.jpeg',
			'../../assets/images/allegria-images/michael-graves/image2.jpeg',
			'../../assets/images/allegria-images/michael-graves/image3.jpeg',
			'../../assets/images/allegria-images/michael-graves/image4.jpeg'
		],
		location: 'VILLA DIRECTLY ON THE GOLF',
		locationAr: 'فيلا مباشرة على الجولف',
		landArea: 850,
		buildingArea: 406,
		floors: 2,
		guard: 9
	},
	{
		name: 'MICHAEL GRAVES BV2',
		nameAr: 'مايكل جريفز بى فى 2',
		images: [
			'../../assets/images/allegria-images/michael-gravesbv2/image1.jpeg',
			'../../assets/images/allegria-images/michael-gravesbv2/image2.jpeg',
			'../../assets/images/allegria-images/michael-gravesbv2/image3.jpeg',
			'../../assets/images/allegria-images/michael-gravesbv2/image4.jpeg'
		],
		location: 'VILLA DIRECTLY ON THE GOLF',
		locationAr: 'فيلا مباشرة على الجولف',
		landArea: 1600,
		buildingArea: 572,
		floors: 2,
		guard: 9
	},
	{
		name: 'MICHAEL GRAVES AV STAND ALONE VILLA',
		nameAr: 'مايكل جرافيس AV فيلا مستقلة',
		images: [
			'../../assets/images/allegria-images/MICHAEL-GRAVES-AV-STAND/image1.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-AV-STAND/image2.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-AV-STAND/image3.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-AV-STAND/image4.jpeg'
		],
		location: 'GOLF COURSE, BAHARY',
		locationAr: 'دورة الجولف ، بحاري',
		landArea: 850,
		buildingArea: 406,
		floors: 2,
		guard: null
	},
	{
		name: 'MICHAEL GRAVES BV2 GOLF COURSE',
		nameAr: 'مايكل جرافيس بي في 2 جولف كورس',
		images: [
			'../../assets/images/allegria-images/MICHAEL-GRAVES-BV2-golf/image1.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-BV2-golf/image2.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-BV2-golf/image3.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-BV2-golf/image4.jpeg',
			'../../assets/images/allegria-images/MICHAEL-GRAVES-BV2-golf/image5.jpeg'
		],
		location: 'ON THE GOLF COURSE',
		locationAr: 'جولف كورس',
		landArea: 1500,
		buildingArea: 488,
		floors: 2,
		guard: 9
	},
];
